import React, { SVGProps } from 'react';

export const VerticalChartIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 26,
  height = 26,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 26 26"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.5834 2.16675H5.41675C3.57508 2.16675 2.16675 3.57508 2.16675 5.41675V20.5834C2.16675 22.4251 3.57508 23.8334 5.41675 23.8334H20.5834C22.4251 23.8334 23.8334 22.4251 23.8334 20.5834V5.41675C23.8334 3.57508 22.4251 2.16675 20.5834 2.16675ZM8.66675 18.4167C8.66675 19.0667 8.23341 19.5001 7.58341 19.5001C6.93341 19.5001 6.50008 19.0667 6.50008 18.4167V14.0834C6.50008 13.4334 6.93341 13.0001 7.58341 13.0001C8.23341 13.0001 8.66675 13.4334 8.66675 14.0834V18.4167ZM14.0834 18.4167C14.0834 19.0667 13.6501 19.5001 13.0001 19.5001C12.3501 19.5001 11.9167 19.0667 11.9167 18.4167V7.58341C11.9167 6.93341 12.3501 6.50008 13.0001 6.50008C13.6501 6.50008 14.0834 6.93341 14.0834 7.58341V18.4167ZM19.5001 18.4167C19.5001 19.0667 19.0667 19.5001 18.4167 19.5001C17.7667 19.5001 17.3334 19.0667 17.3334 18.4167V11.9167C17.3334 11.2667 17.7667 10.8334 18.4167 10.8334C19.0667 10.8334 19.5001 11.2667 19.5001 11.9167V18.4167Z"
        fill="currentColor"
      />
    </svg>
  );
};
